import React from 'react';

export type IconName = `${'hero-' | 'untitled-' | 'brand-'}${string}`;

interface IconProps {
  name: IconName;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, className = '' }) => {
  const classNames = [className];

  classNames.push(name);

  return <span className={classNames.join(' ')} />;
};

export default Icon;
